function pad(value: number) {
	return value.toString().padStart(2, "0");
}

function formatTimecode(seconds: number) {
	const total = Math.floor(seconds);
	const hours = Math.floor(total / 3600);
	const minutes = Math.floor((total % 3600) / 60);
	const secs = total % 60;

	if (hours > 0) {
		return `${hours}:${pad(minutes)}:${pad(secs)}`;
	}

	return `${pad(minutes)}:${pad(secs)}`;
}

export { formatTimecode };
